import { render, staticRenderFns } from "./ListExceptionsOV.vue?vue&type=template&id=1b89b55c&scoped=true&lang=pug"
import script from "./ListExceptionsOV.vue?vue&type=script&lang=js"
export * from "./ListExceptionsOV.vue?vue&type=script&lang=js"
import style0 from "./ListExceptionsOV.vue?vue&type=style&index=0&id=1b89b55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89b55c",
  null
  
)

export default component.exports